
const rateDraft = '{rates-draft}';
export const UPDATE_SAME_AS_CORPORATE_POLICY_NOTES = '{rates-draft} UPDATE_SAME_AS_CORPORATE_POLICY_NOTES';
export const REFRESH_STARTED = `${rateDraft} REFRESH_STARTED`;
export const REFRESH_COMPLETION_CHECK = `${rateDraft} REFRESH_COMPLETION_CHECK`;
export const REFRESH_LEFT_NAV = `${rateDraft} REFRESH_LEFT_NAV`;
export const REFRESH_POLICIES_NOTES = `${rateDraft} REFRESH_POLICIES_NOTES`;
export const REFRESH_PRODUCT_DETAILS = `${rateDraft} REFRESH_PRODUCT_DETAILS`;
export const REFRESH_FINISHED = `${rateDraft} REFRESH_FINISHED`;
export const REVIEW_MY_RATES_DRAFT = `${rateDraft}_REVIEW_MY_RATES_DRAFT`;
export const MANAGE_EXTRAS_OFFERS = `${rateDraft} MANAGE_EXTRAS_OFFERS`;
export const REMOVE_MASTER_TEMPLATE = `${rateDraft} REMOVE_MASTER_TEMPLATE`;

export const ADD_DRAFT_TO_QUEUE = `{contracting} ADD_DRAFT_TO_QUEUE`;
export const REMOVE_DRAFT_FROM_QUEUE = `{contracting} REMOVE_DRAFT_FROM_QUEUE`;

export const SEND_UPDATES_FROM_QUEUE = `{update-queue} SEND_UPDATES_FROM_QUEUE`;
export const CLEAR_QUEUE_STATE = `{update-queue} CLEAR STATE`;

export const REFRESH_TEMPLATE_LIST = `{template-list} REFRESH_TEMPLATE_LIST`;

export const SEND_TOURWRITER = 'SEND_TOURWRITER';

export const REMOVE_SINGLE_FEED_BY_TC_ADMIN = '{history-feed} REMOVE_SINGLE_FEED_BY_TC_ADMIN';
export const GET_NOTES = '{history-feed} GET_NOTES';

export const FILE_CONTRACT_FOR_REQUEST = '{contract-request} FILE_CONTRACT_FOR_REQUEST';

export const REMOVE_CONTRACT_FROM_REQUEST = '{contract-request} REMOVE_CONTRACT_FROM_REQUEST';



// WEBPACK FOOTER //
// ./src/app/components/contracting/__storeFiles__/constants.js